import { SCHEME_IMAGES } from "../../config/insurers";
import { LuShield } from "react-icons/lu";

export const getSchemeImage = (
  schemeTableId,
  { onLoad, onError, className = "", square = false, naturalWidth = false } = {},
) => {
  const schemeImageUrl = SCHEME_IMAGES[schemeTableId];

  if (schemeImageUrl) {
    const imageClasses = square
      ? "tw-h-[60px] tw-max-w-[60px] tw-object-left tw-p-0"
      : naturalWidth
        ? "tw-h-[60px] tw-max-w-[110px] tw-p-0"
      : "tw-h-[60px] tw-max-w-[120px] tw-px-[10px] max-[768px]:tw-mb-[5px] max-[768px]:tw-h-[55px] max-[768px]:tw-max-w-[100px] max-[768px]:tw-px-0";

    return (
      <img
        src={schemeImageUrl}
        alt={`Logo for scheme ${schemeTableId}`}
        onLoad={onLoad}
        onError={onError}
        className={`tw-w-auto tw-rounded-none tw-object-contain ${imageClasses} ${className}`}
      />
    );
  } else {
    const fallbackWidth = square ? "tw-w-[60px]" : "tw-w-[120px]";

    return (
      <div
        role="img"
        aria-label={`Logo for scheme ${schemeTableId}`}
        className={`tw-flex tw-h-[60px] ${fallbackWidth} tw-items-center tw-justify-center tw-rounded-md tw-bg-dis-sky-tint tw-text-dis-deep-blue ${className}`}
      >
        <LuShield className="tw-h-8 tw-w-8" strokeWidth={1.8} aria-hidden="true" />
      </div>
    );
  }
};
